import { HTTP } from '../http';
import store from '../store';

const BASE_SUPPORT_API = 'index.php?api=SupportAdmin';
export default {
  getAllWhiteListedIp(params) {
    return HTTP.post(`${BASE_SUPPORT_API}&a=whiteListedIPs`, { ...params, sessionId: store.state.auth.session.sessionId })
      .then(response => response.data);
  },
  unlockIpPermanently(params) {
    return HTTP.post(`${BASE_SUPPORT_API}&a=unlockIPPermanently`, { ...params, sessionId: store.state.auth.session.sessionId })
      .then(response => response.data);
  },
  unlockIp(params) {
    return HTTP.post(`${BASE_SUPPORT_API}&a=unlockIP`, { ...params, sessionId: store.state.auth.session.sessionId })
      .then(response => response.data);
  },
  getInfosIp(params) {
    return HTTP.post(`${BASE_SUPPORT_API}&a=getIPInfo`, { ...params, sessionId: store.state.auth.session.sessionId })
      .then(response => response.data);
  },
};
